<template>
  <div>
    <button id="orderModalBtn" style="display: none; overflow: auto!important;" data-toggle="modal"
      data-target="#orderModal" @click="prepareCost"></button>
    <div class="modal fade" id="orderModal" tabindex="-1" role="dialog" aria-labelledby="orderModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document" style="min-width: 85%;">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="orderModalLabel">Інформація про послугу</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="!is1cConnected && connectionText" class="connection-status">
              <i class="fa fa-plug"></i>
              <span>{{ connectionText }}</span>
            </div>
            <p class="pl-4 orderModal__towork" v-if="ToWork">
              Створено нове замовлення послуг № {{ order.doc_no }}
            </p>

            <div class="products_table_wrapper" v-if="Products">
              <table class="table table-bordered">
                <thead>
                  <th>Найменування товару/послуги</th>
                  <th>Кількість</th>
                  <th>Од. Вим.</th>
                  <th>Ціна</th>
                  <th>Сума без знижки</th>
                  <th>Знижка</th>
                  <th>Сума</th>
                </thead>
                <tbody>
                  <tr v-for="(product, index) in Products" :key="index">
                    <td>{{ product.Name }}</td>
                    <td>{{ product.Qt }}</td>
                    <td>{{ unit(product.Unit) }}</td>
                    <td>{{ (product.SumNoDiscount / product.Qt).toFixed(2) }}</td>
                    <td>{{ product.SumNoDiscount.toFixed(2) }}</td>
                    <td>{{ product.SumDiscount.toFixed(2) }}</td>
                    <td class="product-sum-cell">
                      <template v-if="product.Sum === 0 || product.Sum === null || product.Sum === undefined">
                        <span class="sum-zero-indicator">

                          <span class="sum-zero-amount">0.00</span>
                          <span v-b-tooltip.hover.top="'Остаточна сума замовлення буде уточнена менеджером'">
                            <i class="fa fa-exclamation-triangle sum-info-icon"></i>
                          </span>
                        </span>
                      </template>
                      <template v-else>
                        {{ product.Sum.toFixed(2) }}
                      </template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <br>
            <p class="pl-4 pr-5">
              <strong class="font-weight-normal">
                Попередня сума:
                <span class="sum-with-info float-right">
                  <span v-if="hasNoPriceItems" class="sum-warning-badge"
                    v-b-tooltip.hover.top="'Остаточна сума та дата готовності замовлення буде уточнена менеджером'">
                    <i class="fa fa-exclamation-triangle"></i>
                    <span class="sum-warning-text">Сума буде уточнена</span>
                  </span>
                  <span class="sum-amount">{{ sum.toFixed(2) }} грн.</span>

                </span>
              </strong>
            </p>

            <p class="pl-4 pr-5">
              <strong class="font-weight-normal" v-if="!Production && Ready">
                Дата готовності: <h4 class="float-right">{{ Ready }} ({{ Days }} днів)</h4>
              </strong>
              <strong class="font-weight-normal" v-else>
                Неможливо поставити в план. Розділіть замовлення на кілька частин або зверніться до менеджера
              </strong>
            </p>

            <hr>
            <!--                        <div class="col-6 orderModal__additional">-->
            <!--                            <p class="mb-3 pl-4">Додатково</p>-->
            <!--                            <div class="custom-control custom-checkbox">-->
            <!--                                <input type="checkbox" class="checkbox-input" id="customCheck1" checked-->
            <!--                                       v-model="mat" value="true">-->
            <!--                                <label for="customCheck1">Очистити Матеріали</label>-->
            <!--                            </div>-->
            <!--                            <div class="custom-control custom-checkbox">-->
            <!--                                <input type="checkbox" class="checkbox-input" id="customCheck2" checked-->
            <!--                                       v-model="edg" value="true">-->
            <!--                                <label for="customCheck2">Очистити Кромки</label>-->
            <!--                            </div>-->
            <!--                            <div class="custom-control custom-checkbox">-->
            <!--                                <input type="checkbox" class="checkbox-input" id="customCheck3" checked-->
            <!--                                       v-model="sc" value="true">-->
            <!--                                <label for="customCheck3">Очистити Стяжки</label>-->
            <!--                            </div>-->
            <!--<div class="custom-control custom-checkbox">-->
            <!--<input type="checkbox" class="custom-control-input" id="customCheck4" checked>-->
            <!--<label class="custom-control-label" for="customCheck4">Очистить Группы</label>-->
            <!--</div>-->
            <!--                        </div>-->
          </div>
          <div class="modal-footer">
            <button type="button" class="button button__grey" data-dismiss="modal">Закрити</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import appconfig from "../../app/config";

export default {
  data() {
    return {
      sum: 0,
      mat: true,
      edg: true,
      sc: true,
      connection: {
        connected: true,
        text: '',
        checkedAt: null
      },
      connectionIntervalId: null,
      units: {
        "006": "м",
        "008": "км",
        "018": "пог. м",
        "055": "м2",
        "112": "л",
        "113": "м3",
        "166": "кг",
        "359": "сут",
        "383": "грн",
        "449": "т. км",
        "607": "банк",
        "616": "бухт",
        "625": "лист",
        "728": "пач",
        "736": "рул",
        "778": "упак",
        "796": "шт",
        "798": "тис. шт",
        "812": "ящ",
        "839": "компл",
      }
    }
  },
  computed: {
    response() {
      return this.$store.state.data.response;
    },
    order() {
      return this.$store.state.data.order;
    },
    ToWork() {
      return this.order ? (this.order.doc_no != '' && this.order.doc_no != null) : false;
    },
    Products() {
      return this.response ? this.response.Products : [];
    },
    Production() {
      return this.response ? this.response.ErrorProduction : false;
    },
    Ready() {
      return this.response ?
        this.response.Ready ?
          this.date()
          : false : false;
    },
    Days() {
      return this.response ?
        this.response.Ready_for_day : false;
    },
    hasNoPriceItems() {
      // Проверяем, есть ли продукты с Sum = 0
      if (this.Products && this.Products.length > 0) {
        return this.Products.some(product => {
          return product.Sum === 0 || product.Sum === null || product.Sum === undefined;
        });
      }
      return false;
    },
    is1cConnected() {
      return this.connection.connected === true;
    },
    connectionText() {
      return this.connection.text || '';
    }
  },
  methods: {
    async fetch1cConnection() {
      try {
        const response = await axios.get(appconfig.Point + 'api/constructor/v1/1c/connection');
        const data = response.data || {};
        this.connection.connected = !!data.connected;
        this.connection.text = data.text || '';
        this.connection.checkedAt = data.checked_at || null;
      } catch (e) {
        this.connection.connected = false;
        this.connection.text = '';
        this.connection.checkedAt = null;
      }
    },
    date() {
      let dateArray = this.response.Ready.split('T')[0].split('-');
      return dateArray[2] + '.' + dateArray[1] + '.' + dateArray[0];
    },
    unit(v) {
      return this.units[v];
    },
    prepareCost() {
      this.sum = 0;
      if (this.Products != undefined) {
        this.Products.forEach((p) => {
          this.sum += p.Sum;
        })
      }
    },
    clear() {

      app.materials = this.mat ? [] : app.materials;
      app.edges = this.edg ? [] : app.edges;
      app.screeds = this.sc ? [] : app.screeds;
      app.groups = [];
      app.details = [];
      app.detail = {};
      app.materialDefault = this.mat ? 0 : app.materialDefault;
      app.edgeDefault = this.edg ? 0 : app.edgeDefault;
    }
  },
  created() {
    this.fetch1cConnection();
    this.connectionIntervalId = setInterval(this.fetch1cConnection, 5 * 60 * 1000);
  },
  beforeDestroy() {
    if (this.connectionIntervalId) {
      clearInterval(this.connectionIntervalId);
      this.connectionIntervalId = null;
    }
  },
  name: "order-modal"
}
</script>

<style scoped>
.sum-with-info {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.sum-amount {
  font-size: 1.5rem;
  font-weight: 500;
  line-height: 1.2;
}

.sum-warning-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.4rem 0.8rem;
  background: #fff3cd;
  border: 2px solid #ffc107;
  border-radius: 6px;
  color: #856404;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: help;
  transition: all 0.3s ease;
  margin-left: 0.5rem;
}

.sum-warning-badge:hover {
  background: #ffe69c;
  border-color: #ff9800;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(255, 193, 7, 0.4);
}

.sum-warning-badge i {
  color: #ff9800;
  font-size: 1.1rem;
  animation: pulse 2s ease-in-out infinite;
}

.sum-warning-text {
  white-space: nowrap;
}

.connection-status {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 1rem 0.75rem;
  padding: 8px 10px;
  border-radius: 6px;
  background: #fff4f4;
  color: #b02a37;
  font-size: 0.85rem;
  border: 1px solid #f5c2c7;
}

.connection-status i {
  font-size: 0.9rem;
}

.product-sum-cell {
  min-width: 130px;
}

.sum-zero-indicator {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}

.sum-info-icon {
  color: #ff9800;
  font-size: 1rem;
}

.sum-zero-amount {
  font-weight: 600;
}

@keyframes pulse {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.7;
  }
}
</style>
